import styled from "styled-components";
import CustomerSupportIcon from "../common/assets/customer-support-icon.png"
import DeliveryIcon from "../common/assets/delivery-icon.png"
import QualityIcon from "../common/assets/quality-icon.png"
import PriceIcon from "../common/assets/price-icon.png"

const WhyAinBhawaniWrapper = styled.div`
    margin-top: 4vh;
    .title{
        display: block !important;
    }
    #card-collection{
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        justify-content: space-between;
        gap: 2vw;
        margin-top: 4vh;

        .card{
            display: flex;
            justify-content: center;
            align-items: center;
            flex-grow: 1;
            flex-direction: column;
            padding: 9vh 3vw;
            background-color: #7398B3;
            color: #fff;
            border-radius: 8px;

            img{
                height: 100px;
                width: auto;
                object-fit: contain;
            }

            span{
                margin-top: 2vh;
            }
            }
            @media screen and (max-width: 1200px){
                grid-template-columns: repeat(2, 1fr);
            }
            @media screen and (max-width: 500px){
                grid-template-columns: 1fr;
            }
        
    }

`

const WhyAinBhawani = () => {
    return (
        <WhyAinBhawaniWrapper>
            <h1 className="title"> Why AinBhawani</h1>
            <div id="card-collection">
                <div className="card">
                    <img src={QualityIcon} alt="quality" />
                    <span>Premium quality raw silver</span>
                </div>
                <div className="card">
                    <img src={PriceIcon} alt="Competitve Price" />
                    <span>Competitive wholesale prices</span>
                </div>

                <div className="card">
                    <img src={DeliveryIcon} alt="timely delivery" />
                    <span>Reliable and timely delivery</span>
                </div>
                <div className="card">
                    <img src={CustomerSupportIcon} alt="Customer Support" />
                    <span>Exceptional customer support</span>
                </div>
            </div>

        </WhyAinBhawaniWrapper>
    )
}

export default WhyAinBhawani;